import { render, staticRenderFns } from "./TransactionHeader.vue?vue&type=template&id=0242ca09"
import script from "./TransactionHeader.vue?vue&type=script&lang=js"
export * from "./TransactionHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports